// services/api/comprasApi.ts
import api from '../../utils/axios';

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4020';

// Interfaces
// services/api/comprasApi.ts
export interface ICompra {
  Id?: number;
  IdProveedor: number;
  IdEstadoCompra: number;
  IdUsuario: number;  // Agregado este campo
  OrdenCompra: string;
  FechaSolicitud: string;
  FechaEntrega?: string;
  Activo: boolean;
  proveedor?: {
    Id: number;
    Nombre: string;
  };
  estadoCompra?: {
    Id: number;
    Nombre: string;
  };
  usuario?: {
    Usuario: string;
  };
}

export interface IArticuloCompra {
  IdArticulo: number;
  IdSucursal: number;
  CantidadComprada: number;
  PrecioCompra: number;
  Nombre?: string;
  CodigoEAN?: string;
}

export interface IDetalleCompra {
  Id: number;
  IdCompra: number;
  IdTipoPago: number;
  FechaRecibo: string;
  NumeroFactura: string;
  Total: number;
  Abono: number;
  Saldo: number;
  Observacion?: string;
  tipoPago?: {
    Nombre: string;
  };
}

export interface IArticuloDetalle {
  id: number;
  IdArticulo: number;
  IdSucursal: number;
  CantidadComprada: number;
  PrecioCompra: number;
  StockActual: number;
  Contador: number;
  articulo: {
    Id: number;
    Nombre: string;
    CodigoEAN: string;
  };
  sucursal: {
    Id: number;
    Nombre: string;
  };
}

export interface IDetalleCompleto {
  compra: ICompra;
  articulosCompra: IArticuloDetalle[];
  detalleCompra: IDetalleCompra | null;
}

const comprasApi = {
  // Catálogos
  getSucursales: async (): Promise<{ Id: number; Nombre: string }[]> => {
    const response = await api.post(`${BASE_URL}/administracion/sucursales/findAll`);
    return response.data;
  },

  // Gestión de Compras
  getAllCompras: async () => {
    const response = await api.post(`${BASE_URL}/compras/findAll`);
    return response.data;
  },

  getCompraById: async (id: number) => {
    const response = await api.post(`${BASE_URL}/compras/findOne/${id}`);
    return response.data;
  },

  createCompra: async (data: Partial<ICompra>) => {
    const response = await api.post(`${BASE_URL}/compras/create`, data);
    return response.data;
  },

  updateCompra: async (id: number, data: Partial<ICompra>) => {
    const response = await api.post(`${BASE_URL}/compras/update/${id}`, data);
    return response.data;
  },

  // Gestión de Artículos en Compra
  getArticulosCompra: async (idCompra: number) => {
    const response = await api.post(`${BASE_URL}/compras/articulos-compra/${idCompra}`);
    return response.data.articulosCompra;
  },

  gestionarArticulo: async (data: {
    IdCompra: number;
    IdArticulo: number;
    IdSucursal: number;
    CantidadComprada: number;
    PrecioCompra: number;
    accion: 'Add' | 'Del';
  }) => {
    const response = await api.post(`${BASE_URL}/compras/gestionar-articulo`, data);
    return response.data;
  },

  createCompraPorArticulo: async (data: {
    IdCompra: number;
    articulosCompra: IArticuloCompra[];
  }) => {
    const response = await api.post(`${BASE_URL}/compras/create-compra-por-Articulo`, data);
    return response.data;
  },

  cancelarCompra: async (idCompra: number) => {
    const response = await api.post(`${BASE_URL}/compras/cancelar/${idCompra}`);
    return response.data;
  },

  finalizarCompra: async (data: {
    IdCompra: number;
    IdTipoPago: number;
    FechaRecibo: Date;
    NumeroFactura: string;
    Abono: number;
    Observacion?: string;
  }) => {
    const response = await api.post(`${BASE_URL}/compras/finalizar-compra`, data);
    return response.data;
  },

 // En comprasApi.ts
getDetalleCompleto: async (idCompra: number) => {
  try {
    const response = await api.post(`${BASE_URL}/compras/detalle-completo/${idCompra}`);
    return response.data;
  } catch (error) {
    console.error('Error en getDetalleCompleto:', error);
    throw error;
  }
}


};

export default comprasApi;